<template>
    <v-sheet>
        <v-tabs v-model="levelThreeTab" color="primary" density="compact">
            <v-tab value="Assembly">Assembly</v-tab>
            <v-tab value="Subassemblies">Subassemblies</v-tab>
        </v-tabs>

        <v-divider></v-divider>

        <v-window v-model="levelThreeTab" class="py-3">
            <v-window-item value="Assembly">
                <AssemblyWindow ref="AssemblyWindowRef" />
            </v-window-item>

            <v-window-item value="Subassemblies">
                <SubassembliesWindow />
            </v-window-item>
        </v-window>
    </v-sheet>
</template>

<script setup>
import { ref, onMounted } from "vue";
import AssemblyWindow from "./AssembliesWindow/AssemblyWindow.vue";
import SubassembliesWindow from "./AssembliesWindow/SubassembliesWindow.vue";
import {useJobEntryStore} from "../../../../../stores/ProjectManagement/JobEntry";
import {storeToRefs} from "pinia";

const jobEntryStore = useJobEntryStore()

const { levelThreeTab } = storeToRefs(jobEntryStore)

</script>

<style scoped>

</style>
